export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import {bind} from 'kpc';

interface Props {
    loading: boolean
    content: string
}

export default class extends Component<Props> {
    static template = template;

    private timer: number | null = null;
    private progressTimer: number | null = null;

    static defaults() {
        return {
            loading: false,
            content: '用户想了解 KingDesign 的使用建议，需要从技术特点、应用场景、成本效益等多个角度分析。',
        };
    }

    beforeUnmount() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    }

    @bind
    startThinking() {
        if (this.timer) {
            clearTimeout(this.timer);
        }

        this.set({
            loading: true,
        });


        // 5秒后完成思考
        this.timer = window.setTimeout(() => {
            this.set({
                loading: false,
            });
        }, 5000);
    }

    @bind
    stopThinking() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
        this.set('loading', false);
    }
}